import { Box } from '@mui/material'
import { Typography } from '../atoms/typography'

export const EmptyPageContent = () => {
	return (
		<Box display={'flex'} justifyContent={'center'} flex={1} alignItems={'center'} height={'100%'} minWidth={'800px'}>
			<Box maxWidth={'456px'} textAlign={'center'}>
				<Typography fontWeight='bold' color='text.secondary' fontSize='xl'>
					Актуальных событий в данном месяце нет
				</Typography>
			</Box>
		</Box>
	)
}
